import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { loginSource } from '@/utils/business'
import i18n from '@/utils/i18n'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 请求取消
const CancelToken = axios.CancelToken
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 2000000
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['Authorization'] = getToken()
    }
    if((config.data && config.data.isStream) || (config.params && config.params.isStream)) {
      config.responseType = 'blob'
    }
    // 收集axios 接口请求方法，用于在路由跳转的时候，取消上个页面没有完成的请求
    config.cancelToken = new CancelToken(function (cancel) {
        window.PC.Cancel && window.PC.Cancel.push(cancel)
    }) 
    /**
     * 所有请求加上的参数
     * languageType 语言环境
     * exhibitionId 展会id
     * subjectType 	角色类型
     * appId        应用ID
     * terminal     终端
     */
    let language = store.getters.language
    let setParams = function(key = 'data') {
      config[key].languageType = language
      config[key].exhibitionId = store.getters.exhibitionId
      config[key].appId = store.getters.appId
      config[key].terminal = store.getters.terminal
      config[key].subjectType = store.getters.subjectType
    }
    if (language == 'zh') language = 'cn'
    if (window.location.pathname == '/liveManage') language = 'cn'
    if (config.data) {
      setParams()
    }
    if (config.params) {
      setParams('params')
    }
    if (!config.data && !config.params) {
      if (config.method === 'post') {
        config.data = {}
        setParams()
      } else if (config.method === 'get') {
        config.params = {}
        setParams('params')
      }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// 响应拦截器
// 修复多个接口请求时, 登录超时会弹出多个弹框问题
let msgBoxNum = 0
service.interceptors.response.use(
  res => {
    const code = res.data.code
    // stream download, just return response data
    if(Array.prototype.toString.call(res.data) === '[object Blob]') {
      return res
    }
    /**
     * 错误编码 为 401、1003 且 msgBoxNum == 0 (没有出现过提示重新登录的弹框)
     */
    if ((code === 401 || code === 1003) && msgBoxNum == 0) {
      ++msgBoxNum
      MessageBox.confirm(
        i18n.t('rLogin.loginExpired'),
        i18n.t('rLogin.systemTip'),
        {
          confirmButtonText: i18n.t('rLogin.loginAgain'),
          type: 'warning',
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      ).then(() => {
        // if (window.location.pathname === '/login') return
        store.dispatch('LogOut').then(() => {
          msgBoxNum = 0
          // window.sessionStorage.cancel()
          loginSource({replaceStatus: true})
        })
      })
      return Promise.reject('error')
    } else if (code !== 1000 && code !== '0000') {
      /**
       * 错误编码 为 401、1003
       * 出现过重新登录的弹框 msgBoxNum == 1 时 弹错误提示
       * 否则 不弹出错误提示
       */
      if ((code === 401 || code === 1003)) {
        if (msgBoxNum == 1) {
          Notification.error({
            title: res.data.message || res.data.msg
          })
        }
        ++msgBoxNum
      } else {
        Notification.error({
          title: res.data.message || res.data.msg
        })
      }
      
      return Promise.reject('error')
    } else {
      return res
    }
  },
  error => {
    if (!axios.isCancel(error)) {
        Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
    }
    return Promise.reject(error)
  }
)

export default service
